import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import {
  MatSlideToggleChange,
  MatSlideToggleModule,
} from '@angular/material/slide-toggle';

@Component({
  selector: 'app-active-toggle',
  imports: [MatSlideToggleModule],
  template: `
    <mat-slide-toggle [checked]="isActive()" (change)="updateToggle($event)">
    </mat-slide-toggle
    ><span>{{ label() }}</span>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
      }
    `,
  ],
})
export class ActiveToggleComponent {
  isActive = input<boolean | undefined>(false);
  label = input<string | undefined>('Aktiv?');
  toggle = output<boolean>();

  updateToggle(event: MatSlideToggleChange) {
    this.toggle.emit(event.checked);
  }
}
